import { render, staticRenderFns } from "./ChatCommand.vue?vue&type=template&id=759e80fa"
import script from "./ChatCommand.vue?vue&type=script&lang=js"
export * from "./ChatCommand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports